import { loadState, saveState } from 'utils/storage';
import { ScenarioPlan } from 'views/playground/features/scenario-planner-2.0/types/scenario-plan.type';
import { UpdateStepThreeInput } from 'views/playground/features/scenario-planner-2.0/types/update-step-three-input.type';

export const putStepThree = async (data: UpdateStepThreeInput): Promise<ScenarioPlan> => {
  const raw = loadState({ key: 'getPlaygroundScenarioPlan', storage: 'session' });

  const parsed = (typeof raw === 'string' ? JSON.parse(raw) : raw) as ScenarioPlan; // try to parse safely

  const updatedScenarioPlan: ScenarioPlan = { ...parsed, stepThreeFields: { ...data } }; // combine data and save in session for test

  saveState({ key: 'getPlaygroundScenarioPlan', storage: 'session', state: updatedScenarioPlan }); // save in session for persistent display

  return updatedScenarioPlan; // return combined data
};
